import nanoid from 'nanoid';
import { put} from 'redux-saga/effects';
import {addNotification, removeNotification, startNotificationTransition} from "./notifications-action-creators";

const delay = ms => new Promise(res => setTimeout(res, ms));


export function* addNotificationRequest(action) {
  const { message, status } = action;
  const id = nanoid();
  yield put(addNotification({ status, message, id }));
  yield delay(100);
  yield put(startNotificationTransition(id));
}

export function* removeNotificationRequest(action) {
  const { id } = action;
  yield put(startNotificationTransition(id));
  yield delay(500);
  yield put(removeNotification(id));
}



// WEBPACK FOOTER //
// ./src/modules/notifications/notifications-saga.js